<template>
  <div>
    <div class="page-head">
      <div>
        <h2>支付记录</h2>
        <p>查看微信支付尝试、订单关联、回调结果和查单状态。支付成功状态只能由微信回调或主动查单更新。</p>
      </div>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="客户编号/支付单号/微信单号/业务订单号" clearable /></el-form-item>
        <el-form-item label="支付状态">
          <el-select v-model="filters.payment_status" placeholder="全部" clearable>
            <el-option label="创建中" value="creating" />
            <el-option label="待支付" value="pending" />
            <el-option label="已支付" value="paid" />
            <el-option label="失败" value="failed" />
            <el-option label="已关闭" value="closed" />
            <el-option label="已退款" value="refunded" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="payment_no" label="支付单号" width="210" />
        <el-table-column prop="payment_scene" label="收款类型" width="100"><template slot-scope="{row}">{{ row.payment_scene === 'supplement' ? '增项补款' : '首次支付' }}</template></el-table-column>
        <el-table-column prop="supplement_title" label="增项名称" min-width="130"><template slot-scope="{row}">{{ row.supplement_title || '-' }}</template></el-table-column>
        <el-table-column prop="order_no" label="业务订单号" width="190" />
        <el-table-column prop="customer_no" label="客户编号" width="205" />
        <el-table-column prop="order_name" label="订单名称" min-width="160" />
        <el-table-column label="用户" min-width="130"><template slot-scope="{ row }">{{ row.nickname || `用户#${row.user_id}` }}</template></el-table-column>
        <el-table-column prop="amount" label="金额" width="100"><template slot-scope="{ row }">¥{{ row.amount }}</template></el-table-column>
        <el-table-column prop="payment_status" label="支付状态" width="105"><template slot-scope="{ row }"><status-tag :value="row.payment_status" /></template></el-table-column>
        <el-table-column prop="trade_state" label="微信状态" width="110" />
        <el-table-column prop="wechat_transaction_id" label="微信支付订单号" min-width="210" show-overflow-tooltip />
        <el-table-column label="支付时间" width="180"><template slot-scope="{ row }">{{ row.paid_at | dateTime }}</template></el-table-column>
        <el-table-column prop="callback_event_id" label="回调事件" min-width="170" show-overflow-tooltip />
        <el-table-column prop="remark" label="人工备注" min-width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="190">
          <template slot-scope="{ row }">
            <el-button type="text" :loading="actionId === row.id" @click="reconcile(row)">微信查单</el-button>
            <el-button v-if="!['paid', 'refunded', 'closed'].includes(row.payment_status)" type="text" class="danger-text" :loading="actionId === row.id" @click="closePayment(row)">关闭</el-button>
            <el-button type="text" @click="editRemark(row)">备注</el-button>
          </template>
        </el-table-column>
      </paged-table>
    </el-card>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import StatusTag from "../components/StatusTag.vue";
import http from "../api/http";

export default {
  name: "PaymentsManage",
  components: { PagedTable, StatusTag },
  data() {
    return {
      loading: false,
      actionId: null,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", payment_status: "" }
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const res = await http.get("/payments", { params: { ...this.filters, page: this.page, pageSize: this.pageSize } });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", payment_status: "" };
      this.page = 1;
      this.fetchList();
    },
    async reconcile(row) {
      this.actionId = row.id;
      try {
        await http.post(`/payments/${row.id}/reconcile`);
        this.$message.success("已从微信支付同步最新状态");
        this.fetchList();
      } finally {
        this.actionId = null;
      }
    },
    async closePayment(row) {
      const { value } = await this.$prompt("关闭前会先向微信查单，已支付订单不会被关闭。请填写关闭原因。", "关闭微信支付订单", {
        inputValidator: (text) => Boolean(String(text || "").trim()) || "请填写关闭原因",
        confirmButtonText: "确认关闭",
        type: "warning"
      });
      this.actionId = row.id;
      try {
        await http.post(`/payments/${row.id}/close`, { reason: value });
        this.$message.success("支付订单已关闭");
        this.fetchList();
      } finally {
        this.actionId = null;
      }
    },
    async editRemark(row) {
      const { value } = await this.$prompt("人工备注不会改变支付状态。", "编辑支付备注", {
        inputValue: row.remark || "",
        inputType: "textarea",
        inputValidator: (text) => Boolean(String(text || "").trim()) || "请填写备注"
      });
      await http.put(`/payments/${row.id}/remark`, { remark: value });
      this.$message.success("备注已保存并记录操作日志");
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.danger-text {
  color: #f56c6c;
}
</style>
